import {useMutation} from "@tanstack/react-query";
import {sendCustomerOfferMutationOptions} from "./send-customer-offer.mutation-options";

export function useSendCustomerOffer(id: string) {
  return useMutation(sendCustomerOfferMutationOptions(id));
}
